import {ICcValorDistribuivel} from "@models/contaContabil/ICcValorDistribuivel.ts";
import {CcDistribuivelInfo} from "@components/contaContabil/valoresDistribuiveis/infoComponent/CcDistribuivelInfo.tsx";
import {useEffect, useState} from "react";
import {useCcDistribuibuivel} from "@components/contaContabil/valoresDistribuiveis/useCcDistribuibuivel.ts";
import {useNavigate, useSearchParams} from "react-router";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {Tab, Tabs} from "@mui/material";

interface CcDistribuivelPageProps {
    presset?: {
        value?: ICcValorDistribuivel
    }
}

type tab = 'Informacao' | 'Distribuicao'

/**
 * Página de informações de distribuição de valores
 * @param props
 * @queryParam contaContabilId{@link number}
 */
export function CcDistribuivelPage(props: CcDistribuivelPageProps) {
    const {getCcValorDistribuivelById} = useCcDistribuibuivel()
    const [tab, setTab] = useState<tab>('Informacao')

    const [searchParams] = useSearchParams()
    const [value, setValue] = useState<ICcValorDistribuivel | null>(props.presset?.value)

    const navigate = useNavigate()

    useEffect(() => {
        setTab(location.hash.slice(1) as tab || 'Informacao')
    }, [location.hash]);

    useEffect(() => {
        if (value == null) {
            const ccId = Number(searchParams.get('contaContabilId'))

            if (ccId > 0) {
                getCcValorDistribuivelById(ccId).then(x => {
                    setValue(x)
                })
            }
        }
    }, [value]);


    return (<DefaultContainer titulo={'Distribuição de valores'}>
        <Tabs value={tab} onChange={(_e, v) => {
            navigate({
                pathname: location.pathname,
                search: location.search,
                hash: v
            })
        }}>
            <Tab label={'Informações'} value={'Informacao'}/>
            <Tab label={'Distribuição'} value={'Distribuicao'}/>
        </Tabs>
        {tab == 'Informacao' && <CcDistribuivelInfo variant={'grid'} value={props.presset?.value}
                                                    expectedId={Number(searchParams.get('contaContabilValorId'))}/>}
    </DefaultContainer>)
}